<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 mt-2">
    <div class="mt-4 text-center">
      <img src="../../../assets/img/av_park_linear_green4.png" height="40px">
    </div>
    @if (title) {
      <h2 class="mt-3 mb-0 text-center">{{ title | translate}}</h2>
    }
  </div>
</div>
